import { css } from "styled-components";
export const valorantSkin = (chroma) => css `
  padding: ${chroma.spacers.bladeEdge.top} 0 ${chroma.spacers.bladeEdge.bottom};
  font-size: 18px;
  line-height: 26px;
  font-weight: 400;

  h2 {
    margin-top: ${chroma.spacers.variable.l};
  }

  h3 {
    padding: ${chroma.spacers.variable.xl} 0 0 ${chroma.spacers.variable.sm};
    font-size: 48px;
    line-height: 48px;
  }

  table {
    margin: ${chroma.spacers.variable.m} 0;
    border: 1px solid #333;
    min-width: 100%;
  }

  td {
    padding: ${chroma.spacers.variable.m};
  }

  p + p {
    margin-top: ${chroma.spacers.variable.s};
  }

  img {
    margin: ${chroma.spacers.variable.m} 0 ${chroma.spacers.variable.s} 0;
    width: 100%;
  }

  ul {
    margin: ${chroma.spacers.variable.s} 0;

    ul {
      margin: 0;
    }
  }
`;
//# sourceMappingURL=index.js.map